<template>
  <div>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 200px)" highlight-current-row>
      <template>
        <el-table-column prop="className" label="班级名称" sortable="custom" show-overflow-tooltip min-width="110" />
        <el-table-column prop="classId" label="班级代码" sortable="custom" show-overflow-tooltip min-width="110" />
      </template>
    </ele-data-table>
  </div>
</template>

<script>
  export default {
    name: 'CodeList',
    data() {
      return {
        table: {
          // 表格配置
          url: '/student/exam/findClassCodeByGradeId',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
      };
    },
    methods: {},
  };
</script>

<style scoped></style>
